<template>
  <div id="userdetail-page" class="mb-5">
    <b-card>
      <b-row>
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/company-structure/supplier"
                >Supplier</router-link
              ></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <form v-on:submit.prevent="doSubmit" class="mt-3">
        <b-row>
          <b-col md="5">
            <b-row>
              <b-col md="12 mt-3">
                <label class="labels">Supplier Name *</label>
                <div class="form-group" v-bind:class="errors.has('name') ? 'has-error' : ''">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:class="errors.has('name') ? 'is-invalid' : ''"
                    data-vv-as="name"
                    name="name"
                    v-model="model.name"
                    v-validate="'required'"
                    placeholder="Enter Supplier Name"
                  />
                  <p v-if="errors.has('name') !== null"></p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12 mt-3">
                <label class="labels">Telephone *</label>
                <div class="form-group" v-bind:class="errors.has('phone') ? 'has-error' : ''">
                  <input
                    type="number"
                    class="form-control"
                    v-bind:class="errors.has('phone') ? 'is-invalid' : ''"
                    data-vv-as="phone"
                    name="phone"
                    v-model="model.phone"
                    v-validate="'required'"
                    placeholder="Enter Telephone"
                  />
                  <p v-if="errors.has('phone') !== null"></p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <label class="labels">Fax Number </label>
                <div class="form-group" v-bind:class="errors.has('fax') ? 'has-error' : ''">
                  <input
                    type="number"
                    class="form-control"
                    v-bind:class="errors.has('fax') ? 'is-invalid' : ''"
                    data-vv-as="fax"
                    name="fax"
                    v-model="model.fax"
                    placeholder="Enter Fax Number"
                  />
                  <p v-if="errors.has('fax') !== null"></p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <label class="labels">Website </label>
                <div class="form-group" v-bind:class="errors.has('website') ? 'has-error' : ''">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:class="errors.has('website') ? 'is-invalid' : ''"
                    data-vv-as="website"
                    name="website"
                    v-model="model.website"
                    placeholder="Enter Website"
                  />
                  <p v-if="errors.has('website') !== null"></p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <label class="labels">Email *</label>
                <div class="form-group" v-bind:class="errors.has('email') ? 'has-error' : ''">
                  <input
                    type="email"
                    class="form-control"
                    v-bind:class="errors.has('email') ? 'is-invalid' : ''"
                    data-vv-as="email"
                    name="email"
                    v-model="model.email"
                    v-validate="'required'"
                    placeholder="Ex: myname@example.com"
                  />
                  <p v-if="errors.has('email') !== null"></p>
                </div>
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col md="11">
                <label class="labels">Social Media </label>
                <b-button
                  id="buttonAdds"
                  variant="primary"
                  class="btn-custom"
                  @click="addSocialMedia()"
                  ><font-awesome-icon icon="plus"
                /></b-button>
                <div v-for="(socialMedia, index) in socialMedias" v-bind:key="index">
                  <b-form-input
                    type="text"
                    class="mt-2"
                    placeholder="Enter Social Media"
                    v-model="socialMedia.name"
                  />
                  <b-button
                    class="deleteSocialMedia"
                    pill
                    style="margin-top:-60px!important;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important;"
                    size="sm"
                    variant="danger"
                    @click="deleteSocialMedia(index)"
                    >x</b-button
                  >
                </div>
              </b-col>
            </b-row> -->
          </b-col>
          <b-col md="2"> </b-col>
          <b-col md="5">
            
            <b-row>
              <b-col md="12">
                <label class="labels">Tax ID </label>
                <div class="form-group" v-bind:class="errors.has('taxId') ? 'has-error' : ''">
                  <input
                    type="number"
                    class="form-control"
                    v-bind:class="errors.has('taxId') ? 'is-invalid' : ''"
                    data-vv-as="taxId"
                    name="taxId"
                    v-model="model.taxId"
                    placeholder="Enter Tax ID"
                  />
                  <p v-if="errors.has('taxId') !== null"></p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <label class="labels">State *</label>
                <b-form-select
                  name="state"
                  v-model="model.state"
                  v-validate="modelValidations.state"
                  v-bind:class="errors.has('state') ? 'is-invalid' : ''"
                  :error="errors.first('state')"
                  :options="stateList"
                >
                </b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <label class="labels">Address *</label>
                <div class="form-group" v-bind:class="errors.has('address') ? 'has-error' : ''">
                  <b-form-textarea
                    rows="5"
                    type="text"
                    class="pb-0 mb-0 form-control"
                    v-bind:class="errors.has('address') ? 'is-invalid' : ''"
                    data-vv-as="address"
                    name="address"
                    v-model="model.address"
                    v-validate="'required'"
                    placeholder="Enter Address"
                  />
                  <p v-if="errors.has('address') !== null"></p>
                </div>
              </b-col>
            </b-row>
            
            <b-row>
              <b-col md="12 mt-3">
                <label class="labels">City *</label>
                <b-form-select
                  v-if="model.state === 'Malaysia'"
                  name="city"
                  v-model="model.city"
                  v-validate="modelValidations.city"
                  v-bind:class="errors.has('city') ? 'is-invalid' : ''"
                  :error="errors.first('city')"
                  :options="cityListRM"
                >
                </b-form-select>
                <b-form-select
                  v-else
                  name="city"
                  v-model="model.city"
                  v-validate="modelValidations.city"
                  v-bind:class="errors.has('city') ? 'is-invalid' : ''"
                  :error="errors.first('city')"
                  :options="cityListID"
                >
                </b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12 mt-3">
                <label class="labels">Postal Code *</label>
                <div class="form-group" v-bind:class="errors.has('postalCode') ? 'has-error' : ''">
                  <input
                    type="number"
                    class="form-control"
                    v-bind:class="errors.has('postalCode') ? 'is-invalid' : ''"
                    data-vv-as="postalCode"
                    name="postalCode"
                    v-model="model.postalCode"
                    v-validate="'required'"
                    placeholder="Enter Postal Code"
                  />
                  <p v-if="errors.has('postalCode') !== null"></p>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-row>
              <b-col md="12 mt-3">
                <label class="labels">Description </label>
                <div class="form-group" v-bind:class="errors.has('description') ? 'has-error' : ''">
                  <b-form-textarea
                    rows="5"
                    type="text"
                    class="form-control"
                    v-bind:class="errors.has('description') ? 'is-invalid' : ''"
                    data-vv-as="description"
                    name="description"
                    v-model="model.description"
                    placeholder="Enter Description"
                  />
                  <p v-if="errors.has('description') !== null"></p>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col md="6">
            <b-button variant="secondary" class="btn-back float-left" @click="goBack()"
              ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
            >
          </b-col>
          <b-col md="6">
            <b-button
              :variant="$route.params.id !== undefined ? 'warning' : 'primary'"
              class="btn-back float-right"
              type="submit"
              ><font-awesome-icon icon="save"></font-awesome-icon>
              {{ $route.params.id !== undefined ? 'Update' : 'Save' }}
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'customer-form',
  data() {
    return {
      isLoading: false,
      socialMedias: [],
      socialMedia: {},
      apiUrl: {
        supplier: window.AppConfig.apiUrl + 'supplier',
      },
      urlName: null,
      model: {
        branch: '',
        website: '',
        fax: '',
        city: null,
        state: 'Indonesia',
        postalCode: '',
        description: '',
        taxId: '',
        name: '',
        gender: '',
        email: '',
        workemail: '',
        workphone: '',
        address: '',
        picName: '',
        whatsapp: '',
        phone: '',
      },
      typeList: [
        {
          value: 'Company',
          text: 'Company',
        },
        {
          value: 'Personal',
          text: 'Personal',
        },
      ],

      taxCategoryList: [
        {
          value: '',
          text: 'Please Select Tax Category',
        },
      ],
      positionList: [
        {
          value: '',
          text: 'Please Select Position',
        },
      ],
      businessSectorList: [
        {
          value: '',
          text: 'Please Select Business Sector',
        },
      ],
      genderList: [
        {
          value: '',
          text: 'Please Select Gender',
        },
        {
          value: 'Male',
          text: 'Male',
        },
        {
          value: 'Female',
          text: 'Female',
        },
      ],
      divisionList: [
        {
          value: '',
          text: 'Please Select Division',
        },
      ],
      stateList: [
        {
          value: 'Indonesia',
          text: 'Indonesia',
        },
        {
          value: 'Malaysia',
          text: 'Malaysia',
        },
      ],
      cityListRM: [
        {
          value: null,
          text: 'Please Select City',
        },
        {
          value: 'Ipoh',
          text: 'Ipoh',
        },
        {
          value: 'Johor Bahru',
          text: 'Johor Bahru',
        },
        {
          value: 'Klang',
          text: 'Klang',
        },
        {
          value: 'Kelantan',
          text: 'Kelantan',
        },
        {
          value: 'Kota Kinabalu',
          text: 'Kota Kinabalu',
        },
        {
          value: 'Kuala Lumpur',
          text: 'Kuala Lumpur',
        },
        {
          value: 'Kuching',
          text: 'Kuching',
        },
        {
          value: 'Melaka',
          text: 'Melaka',
        },
        {
          value: 'Penang',
          text: 'Penang',
        },
        {
          value: 'Sabah',
          text: 'Sabah',
        },
        {
          value: 'Seberang Parai',
          text: 'Seberang Parai',
        },
        {
          value: 'Taiping',
          text: 'Taiping',
        },
        {
          value: 'Other',
          text: 'Other',
        },
      ],
      cityListID: [
        {
          value: null,
          text: 'Please Select City',
        },
        {
          value: 'Aceh',
          text: 'Aceh',
        },
        {
          value: 'Bali',
          text: 'Bali',
        },
        {
          value: 'Bandung',
          text: 'Bandung',
        },
        {
          value: 'Banjarmasin',
          text: 'Banjarmasin',
        },
        {
          value: 'Bekasi',
          text: 'Bekasi',
        },
        {
          value: 'Bogor',
          text: 'Bogor',
        },
        {
          value: 'Depok',
          text: 'Depok',
        },
        {
          value: 'Jakarta',
          text: 'Jakarta',
        },
        {
          value: 'Makassar',
          text: 'Makassar',
        },
        {
          value: 'Manado',
          text: 'Manado',
        },
        {
          value: 'Medan',
          text: 'Medan',
        },
        {
          value: 'Padang',
          text: 'Padang',
        },
        {
          value: 'Palembang',
          text: 'Palembang',
        },
        {
          value: 'Papua',
          text: 'Papua',
        },
        {
          value: 'Pekanbaru',
          text: 'Pekanbaru',
        },
        {
          value: 'Samarinda',
          text: 'Samarinda',
        },
        {
          value: 'Semarang',
          text: 'Semarang',
        },
        {
          value: 'Surabaya',
          text: 'Surabaya',
        },
        {
          value: 'Other',
          text: 'Other',
        },
      ],

      modelValidations: {
        name: {
          required: true,
        },
        email: {
          required: true,
        },
        description: {
          required: true,
        },
        address: {
          required: true,
        },
        phone: {
          required: true,
        },
        state: {
          required: true,
        },
        city: {
          required: true,
        },
      },
      formData: {
        name: null,
        note: null,
      },
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    addSocialMedia() {
      this.socialMedias.push({
        name: '',
      });
    },
    deleteSocialMedia(index) {
      this.socialMedias.splice(index, 1);
    },
    initData() {
      if (this.$route.params.id !== undefined) {
        this.getDetail();
      }
    },
    getDetail() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.supplier + '/' + this.$route.params.id)
        .then((response) => {
          this.model.name = response.data.name;
          this.model.address = response.data.address;
          this.model.workphone = response.data.workphone;
          this.model.email = response.data.email;
          this.model.workemail = response.data.workemail;
          this.model.taxId = response.data.taxId;
          this.model.description = response.data.description;
          this.model.fax = response.data.fax;
          this.model.website = response.data.website;
          this.model.city = response.data.city;
          this.model.state = response.data.state;
          this.model.postalCode = response.data.postalCode;
          this.model.picName = response.data.picName;
          this.model.whatsapp = response.data.whatsapp;
          this.model.phone = response.data.phone;
          if (response.data.socialMedia !== null) {
            this.socialMedias = response.data.socialMedia.map((socialMedia) => {
              const jsonnn = JSON.stringify(socialMedia);
              return {
                name: JSON.parse(jsonnn.replace(/(\{|,)\s*(.+?)\s*:/g, '$1 "$2":')),
              };
            });
          }
        });
    },

    doSubmit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          let formData = new FormData();
          formData.append('name', this.model.name);
          formData.append('description', this.model.description);
          formData.append('email', this.model.email);
          formData.append('whatsapp', this.model.whatsapp);
          formData.append('website', this.model.website);
          formData.append('phone', this.model.phone);
          formData.append('taxId', this.model.taxId);
          formData.append('state', this.model.state);
          formData.append('city', this.model.city);
          formData.append('fax', this.model.fax);
          formData.append('postalCode', this.model.postalCode);
          formData.append('address', this.model.address);
          formData.append('fax', this.model.fax);
          if (this.$route.params.id !== undefined) {
            this.$http
              .patch(this.apiUrl.supplier + '/' + this.$route.params.id, formData)
              .then((response) => {
                this.$store.dispatch('notification/success', 'Supplier has been updated.');
                window.location.href = document.URL.replace('/edit', '');
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
              });
          } else {
            this.$http
              .post(this.apiUrl.supplier, formData)
              .then((response) => {
                this.$store.dispatch('notification/success', 'Supplier has been added.');
                window.location.href = document.URL.replace(
                  '/add-supplier',
                  '/' + response.data.uuid,
                );
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
              });
          }
        } else {
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
        }
      });
    },
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm A');
      } else {
        return '-';
      }
    },
    goBack() {
      window.goBack(this);
    },
  },
};
</script>
